import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Loader from 'components/Loader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Country as CountryModel } from 'models/country';

import { Container, Header, BackButton, NextButton, ButtonsContainer, ButtonLine } from '../../styles';
import { CountryContainer, CountryButton, CountryFlag, CountryName } from './styles';

export interface CountryValues {
  country: CountryModel;
}

interface Props {
  values: CountryValues | null;
  onSubmit: (values: CountryValues) => void;
  loadingCountries: boolean;
  countryList: CountryModel[];
}

const Country = ({ values, onSubmit, loadingCountries, countryList }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const [selected, setSelected] = useState<CountryModel | null>(null);

  useEffect(() => {
    if (values) setSelected(values.country);
  }, [values]);

  const handleSelect = (country: CountryModel) => setSelected(country);

  const handleBack = () => history.goBack();

  const handleSubmit = (formValues: CountryValues) => onSubmit(formValues);

  return (
    <Container>
      <Header>{t('registrationOnboarding.country.title')}</Header>

      <CountryContainer>
        {loadingCountries ? (
          <Loader />
        ) : (
          countryList.map((country) => (
            <CountryButton
              key={country.id}
              onClick={() => handleSelect(country)}
              selected={selected?.id === country.id}
            >
              <CountryFlag imageUrl={`/images/flags/${country.id}.png`} />
              <CountryName>{t([`countries.${country.id}`, country.name])}</CountryName>
            </CountryButton>
          ))
        )}
      </CountryContainer>

      <ButtonsContainer>
        <ButtonLine>
          <BackButton onClick={handleBack}>{t('registrationOnboarding.backButton')}</BackButton>
          <NextButton
            disabled={selected === null}
            onClick={() => {
              if (!selected) return;
              handleSubmit({ country: selected });
            }}
          >
            {t('registrationOnboarding.nextButton')}
          </NextButton>
        </ButtonLine>
      </ButtonsContainer>
    </Container>
  );
};

export default Country;
